import { useEffect, useRef } from 'react';

export function LoadMoreTarget({ hasMore, onLoadMore }: { hasMore?: boolean; onLoadMore?: () => void }) {
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!hasMore) {
            return;
        }

        const target = ref.current;

        if (target === null) {
            return;
        }

        function onIntersection(entries: IntersectionObserverEntry[]) {
            if (onLoadMore && entries[0].isIntersecting) {
                onLoadMore();
            }
        }

        const observer = new IntersectionObserver(onIntersection, {
            // root: scrollContainer,
            rootMargin: '250px',
        });

        observer.observe(target);

        return () => {
            observer.unobserve(target);
        };
    }, [hasMore, onLoadMore]);

    return <div ref={ref}></div>;
}
